/**
 * DemoCTA — Call-to-action box shown in the insight area
 * for users on the DEMO subscription tier.
 */
import { useLocation } from 'wouter-preact'

export default function DemoCTA() {
  const [, setLocation] = useLocation()
  return (
    <div className="radar-demo-cta">
      <div className="radar-demo-cta__card">
        <p className="radar-demo-cta__card-text">
          You're seeing the full market picture — every measured cell is on this
          chart. Unlock per-cell detail, quantitative insights and exports with PRO.
        </p>
        <button className="radar-demo-cta__btn" onClick={() => setLocation('/plans')}>
          Unlock Full Radar Access
        </button>
      </div>
    </div>
  )
}
